import React from "react";
import { EllipsisMenu } from "../../ui/menu/EllipsisMenu";
import { ActionsCellProps } from "../types";

export const ActionsCell: React.FC<ActionsCellProps> = ({
  items,
  trigger,
  className = "",
}) => {
  return (
    <div className={`flex ${className}`}>
      <EllipsisMenu items={items} trigger={trigger} />
    </div>
  );
};
